module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"policyPopupText":"Questo sito utilizza cookies tecnici e di terze parti per funzionalità quali la condivisione sui social network e/o la visualizzazione di media. Utilizzando questo sito acconsenti all\u0027utilizzo dei cookie di terze parti. Per maggiori informazioni consulta la {0}.","policyPopupYes":"OK"},"en":{"policyPopupText":"This site uses technical and third-party cookies for features such as sharing on social networks and / or media viewing. By using this site you consent to the use of third-party cookies. For more information see {0}.","policyPopupYes":"OK"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/app/home/app.vue
// module id = 96
// module chunks = 0